module.exports = __webpack_public_path__ + "static/media/WANTANCA_MENU-normal.0c283205.png";